import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';

import { getToken } from './token';

export const createHttpClient = (baseURL: string, options: AxiosRequestConfig = {}) => {
	const client = axios.create({
		baseURL,
		headers: {
			'X-BONUSLY-SOURCE': 'internal',
		},
		xsrfCookieName: 'X-CSRF-TOKEN',
		xsrfHeaderName: 'X-CSRF-TOKEN',
		withCredentials: true,
		...options,
	});

	client.defaults.paramsSerializer = (params) => {
		return qs.stringify(params, { arrayFormat: 'brackets' });
	};

	client.interceptors.request.use(async (config) => {
		const token = await getToken();

		if (token && config.headers) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	});

	client.interceptors.response.use(
		(response) => response,
		(error) => {
			return Promise.reject(error);
		}
	);

	return client;
};
